import { MenuItem } from 'primeng/api';

export const MenuItems: MenuItem[] = [
  {
    label: 'Home',
    icon: 'pi pi-home',
    route: ['/']
  },
  {
    label: 'Companies',
    icon: 'pi pi-building',
    route: ['/company'],
    requiredPolicy: 'GCM.Company',
  },
  {
    label: 'Foreign Nationals',
    icon: 'pi pi-user',
    route: ['/foreign-national'],
    requiredPolicy: 'GCM.ForeignNational',
  },
  {
    label: 'Matters',
    icon: 'pi pi-pen-to-square',
    route: ['/matter'],
    requiredPolicy: 'GCM.Matter',
  },
  {
    label: 'Tasks',
    icon: 'pi pi-check-square',
    route: ['/tasks'],
    requiredPolicy: 'GCM.EmployerTask',
  },
  {
    label: 'Reports',
    icon: 'pi pi-clipboard',
    items: [
      {
        label: 'Reports',
        route: ['/report'],
        requiredPolicy: 'GCM.Report',
      },
      {
        label: 'Ad Hoc Reports',
        route: ['/ad-hoc-reports'],
        requiredPolicy: 'GCM.AdHocReport',
      }
    ]
  },
  {
    label: 'Reminders',
    icon: 'pi pi-bell',
    // items: [
    //   {
    //     label: 'Open Matters by Case Manager',
    //     route: ['/report/open-matters']
    //   },
    //   {
    //     label: 'Report 2',
    //     route: ['/reports/report-2']
    //   }
    // ],
    route: ['/reminder'],
    requiredPolicy: 'GCM.Reminder',
  },
  {
    label: 'Resources',
    icon: 'pi pi-globe',
    items: [
      {
        label: 'Employee Resources',
        target: '_blank',
        url: 'https://gotcherlaw.sharepoint.com/sites/EmployeeResources/Shared%20Documents/Forms/AllItems.aspx'
      },
      {
        label: 'Client Docs (SPO)',
        target: '_blank',
        url: 'https://gotcherlaw.sharepoint.com/sites/Clients/SitePages/CollabHome.aspx'
      },
      {
        label: 'Internal Resources',
        target: '_blank',
        url: 'https://gotcherlaw.sharepoint.com/sites/Resources/SitePages/Home.aspx?csf=1&web=1&share=Ec4a2uC-Id5GtT1X4ML0fTEB6gQ2AMPSvzKUfVzFQn-3ng&e=4%3aIVaCyU&fromShare=true&at=9&cid=88e9f374-1ca6-401c-9665-92556e96f877'
      },
      {
        label: 'GCM Training',
        target: '_blank',
        url: 'https://gotcherlaw.sharepoint.com/sites/GCMTrainingCenter/SitePages/TrainingHome.aspx'
      }
    ]
  },
  {
    label: 'Portal Action Tasks',
    icon: 'pi pi-check',
    route: ['/portal-action-tasks'],
    requiredPolicy: 'GCM.PortalActionTasks',
  },
  {
    label: 'Admin',
    icon: 'pi pi-user',
    requiredPolicy: 'AbpIdentity.Users.Create',
    items: [
      {
        label: 'Users',
        route: ['/admin/users'],
        requiredPolicy: 'AbpIdentity.Users'
      },
      {
        label: 'Roles',
        route: ['/admin/roles'],
        requiredPolicy: 'AbpIdentity.Roles'
      },
      {
        label: 'Process Modules',
        route: ['/admin/process-modules'],
        requiredPolicy: 'GCM.ProcessModule'
      },
      {
        label: 'Workflow Templates',
        route: ['/admin/workflow-templates'],
        requiredPolicy: 'GCM.ProcessTemplate'
      },
      {
        label: 'Keywords',
        route: ['/admin/keyword'],
        requiredPolicy: 'GCM.Keyword'
      },
      {
        label: 'Email Templates',
        route: ['/admin/email-templates'],
        requiredPolicy: 'AbpIdentity.Users'
      },
      {
        label: 'Task Templates',
        route: ['/admin/task-templates'],
        requiredPolicy: 'AbpIdentity.Users'
      },
      {
        label: 'Letter Templates',
        route: ['/admin/letter-templates'],
        requiredPolicy: 'AbpIdentity.Users'
      },
      {
        label: 'Forms',
        route: ['/admin/forms'],
        requiredPolicy: 'GCM.Form'
      },
      {
        label: 'E-File Status',
        route: ['/admin/e-file'],
        requiredPolicy: 'AbpIdentity.Users'
      },
      {
        label: 'Questionnaires',
        route: ['/admin/questionnaires'],
      },
      {
        label: 'System Alerts',
        route: ['/admin/alert-setting'],
        requiredPolicy: 'AbpIdentity.Users'
      },

      {
        label: 'Visa Bulletin',
        route: ['/admin/visa-bulletin']
      },
      {
        label: 'Document Requests',
        route: ['/admin/document-requests'],
        requiredPolicy: 'GCM.DocRequest'
      }
    ]
  }
];
